export const weighbridgeOpsEn = {
  weighbridgeOps: {
    title: 'Weighbridge Operations',
    subtitle: 'Live scale monitoring & weight capture',
    connection: {
      connected: 'Connected',
      connecting: 'Connecting...',
      reconnecting: 'Reconnecting...',
      disconnected: 'Disconnected',
      noInternet: 'No Internet',
    },
    stage: {
      firstWeight: 'First Weight',
      secondWeight: 'Second Weight',
    },
    gate: {
      entry: 'Entry Gate',
      exit: 'Exit Gate',
      open: 'OPEN',
      closed: 'CLOSED',
      openBtn: 'Open',
      closeBtn: 'Close',
      notConfigured: 'Not configured',
      openAria: 'Open',
      closeAria: 'Close',
    },
    panel: {
      firstWeight: 'First Weight',
      secondWeight: 'Second Weight',
      idle: 'Waiting for truck',
      capturing: 'Capturing...',
      captured: 'Weight Captured',
      capturedAt: 'Captured at',
      error: 'Capture failed',
      captureButton: 'Capture Weight',
      override: 'Override — Capture Now',
      weightUnit: 'kg',
      adminOverrideTitle: 'Admin Override — Manual Weight',
      weightPlaceholder: 'Enter weight (kg)',
      setWeight: 'Set Weight',
      enterOrderFirst: 'Enter order number first',
      saveContinue: 'Save & Continue',
      saving: 'Saving…',
      clearWeight: 'Clear',
      zeroCheck: {
        title: 'Checking Scale',
        reading: 'Scale reads {{weight}} kg — waiting for zero',
      },
      stageLocked: 'Stage locked',
      stageLockedByOrder: '— error for order {{orderNumber}}.',
      stageLockedOpenGate: 'Open the exit gate to unlock.',
      stageLockedTitle:
        'Locked by order {{orderNumber}} — open exit gate to unlock',
      stageLockedTitleNoOrder: 'Stage locked — open exit gate to unlock',
      lockedBadge: 'LOCKED · {{orderNumber}}',
      lockedBadgeNoOrder: 'LOCKED',
      inQueueBadge: '{{count}} in queue',
      overweightWarning: {
        title: 'Weight Variance Warning',
        description:
          'Net {{netWeight}} differs from planned {{plannedWeight}} by {{deltaKg}} kg.',
      },
      overweightConfirm: {
        title: '⚠ Weight Variance — Action Required',
        description:
          'Net weight {{netWeight}} kg differs from planned {{plannedWeight}} kg by {{deltaKg}} kg. How do you want to proceed?',
        continueBtn: 'Continue & Submit',
        rejectBtn: 'Reject & Skip',
      },
      recordedWeights: 'Recorded Weights',
      tare: 'Tare',
      gross: 'Gross',
      net: 'Net',
      liveWeightSummary: {
        title: 'Weight Summary',
        tare: 'Tare (1st)',
        gross: 'Gross (2nd)',
        inboundGross: 'Gross (1st)',
        inboundTare: 'Tare (2nd)',
        net: 'Net Weight',
        noTare: 'Tare weight not yet recorded for this order',
        noGross: 'Gross weight not yet recorded for this shipment',
      },
    },
    queue: {
      title: 'Active Queue',
      empty: 'No trucks in queue',
      manualEntry: 'Manual Order Entry',
      manualInboundEntry: 'Manual Shipment Entry',
      manualPlaceholder: 'Enter order number...',
      manualInboundPlaceholder: 'Enter shipment number...',
      manualEntryDesc: ' ',
      inbound: 'Inbound',
      outbound: 'Outbound',
      orderNumber: 'Order',
      shipmentNumber: 'Shipment',
      waitJustNow: 'just now',
      waitSeconds: '{{secs}}s',
      waitMinutesSeconds: '{{mins}}m {{secs}}s',
      statusActive: 'Active',
      statusWaiting: 'Waiting',
      removeFromQueue: 'Remove from queue',
      removeFromQueueTitle:
        'Order {{orderNumber}} is in queue — click to remove it',
      driver: 'Driver',
      plate: 'Vehicle Plate',
      firstWeight: 'First Weight',
      secondWeight: 'Second Weight',
      firstWeightLabel: 'W1',
      secondWeightLabel: 'W2',
      packagingBags: 'Bags',
      packagingBulk: 'Bulk',
      plannedWeight: 'Planned Weight',
      plannedWeightValue: '{{weight}} kg',
      weightPending: '—',
      loadingDetails: 'Loading details...',
    },
    history: {
      title: 'Session History',
      empty: 'No events yet',
      clearButton: 'Clear',
      sinceNote: 'Since connection opened — in-memory only',
      internetConnected: 'Internet connection restored',
      internetDisconnected: 'Internet connection lost',
      connected: 'Connected to weighbridge controller',
      disconnected: 'Disconnected from controller',
      orderQueued: '{{flowLabel}} {{identifier}} queued via {{source}} — {{stage}}',
      orderEnqueued: '{{flowLabel}} {{identifier}} waiting in queue — {{stage}}',
      captureStarted: '{{stage}} capture started{{orderSuffix}}',
      weightCaptured: '{{stage}} captured: {{weight}} kg{{orderSuffix}}',
      weightSaved: '{{stage}} saved: {{weight}} kg{{orderSuffix}}',
      captureError: '{{stage}} error: {{error}}{{orderSuffix}}',
      gateChanged: '{{gate}} gate {{status}}{{stageSuffix}}',
      anprDetected: 'ANPR: {{plate}}{{orderSuffix}}',
      scaleNotClear:
        'Scale not clear ({{weight}} kg) — attempt {{attempt}}/{{maxAttempts}}',
      scaleCleared: 'Scale cleared — ready',
      truckDeparted: 'Truck departed — exit gate closed',
      sourceQrScan: 'QR scan',
      sourceAnpr: 'ANPR',
      sourceManual: 'manual entry',
      stageLocked:
        '⚠️ {{stage}} LOCKED — error for {{flowLabel}} {{identifier}}. Open exit gate to unlock.',
      stageUnlocked: '✅ {{stage}} unlocked — resuming normal operation.',
      captureRequestFailed: 'Capture request failed: {{error}}',
      bootSnapshot: 'Controller state snapshot at page load',
      bootLog: '📋 {{message}}',
      gateOpenFailed: 'Gate open failed: {{error}}',
      gateOpenError: 'Gate open error: {{error}}',
      gateCloseFailed: 'Gate close failed: {{error}}',
      gateCloseError: 'Gate close error: {{error}}',
      saveNoController: 'Save failed: controller URL not configured',
      saveSubmitted:
        '{{stage}} save submitted: {{weight}} kg ({{orderNumber}})',
      saveFailed: 'Save failed: {{error}} ({{orderNumber}})',
      saveAckTimeout:
        '⚠️ Save acknowledgment timed out — WS event may have been lost. Save button re-enabled.',
      overweightConfirmRequired: '⚠️ Overweight detected — operator action required',
      boot: {
        gate_open_command_issued: 'Gate open command issued ({{stage}})',
        gate_close_command_issued: 'Gate close command issued ({{stage}})',
        truck_departed: 'Truck departed',
      },
    },
    zone: {
      loading: 'Loading weighbridge zone...',
      noZone: 'No weighbridge zone found for this factory.',
      noController:
        'Zone has no controller URL configured. Contact your system administrator.',
      noTenantOrFactory: 'No tenant or factory associated with your account.',
    },
    errors: {
      fetchZoneFailed: 'Failed to load weighbridge zone',
      flowBusy: 'Weighbridge is busy. Please wait and try again.',
      flowBusyOrder:
        'Weighbridge is busy processing order {{orderNumber}}. Please wait.',
      // Fulfillment controller / service
      orderNumberRequired: 'Order number is required',
      tareWeightRequired: 'Tare weight is required',
      grossWeightRequired: 'Gross weight is required',
      licensePlateRequired: 'License plate is required',
      firstWeighFailed: 'Failed to record first weigh',
      secondWeighFailed: 'Failed to record second weigh',
      validateOrderFailed: 'Failed to validate order',
      resolveByPlateFailed: 'Failed to resolve order by plate',
      orderNotFound: 'Order not found',
      shipmentNotFound: 'Shipment not found for this order',
      tareWeightImmutable:
        'Cannot update tare weight once gross weight has been recorded',
      netWeightInvalid: 'Net weight must be greater than zero',
      orderAlreadyProcessing: 'Order is already being processed',
      orderStatusInvalid:
        'Order cannot be processed — it is not in the required status',
      orderStatusNotProcessing: 'Order status must be processing',
      shipmentResourceRequired:
        'Shipment resource is required before starting processing',
      shipmentNotLoading: 'Shipment must be in loading status for second weigh',
      firstWeighRequired:
        'First weigh (tare weight) must be completed before second weigh',
      firstWeighAlreadyCompleted: 'First weigh is already completed for this shipment',
      firstAndSecondWeighRequired:
        'First and second weigh must be completed before exit',
      bagsVarianceNotConfigured:
        'Bags variance check is not configured for this variant',
      bagsWeightVarianceExceeded:
        'Weight variance {{variancePercent}}% exceeds allowed {{thresholdPercent}}% for bags orders. Planned: {{plannedTonnes}}t, Actual: {{actualTonnes}}t',
      contractOverload:
        'Contract overload blocked at second weigh. Overload cost {{actualCost}} exceeds available contract balance {{availableBalance}}. Deficit: {{deficit}}.',
      assetNotFoundForPlate: 'No active asset found for this license plate',
      assetNotInResource: 'Asset found but not assigned to any active resource',
      resourceNotInShipment: 'Resource found but not assigned to any shipment',
      noOrderForPlate: 'No active order found for this vehicle license plate',
      resourceNotFound: 'Selected resource not found',
      // Edge command controller
      siteIdRequired: 'Site ID is required',
      pollCommandsFailed: 'Failed to poll commands',
      invalidCommandStatus: 'Command status must be completed or failed',
      edgeCommandNotFound: 'Edge command not found',
      edgeCommandAlreadyAcked: 'Command has already been acknowledged',
      ackCommandFailed: 'Failed to acknowledge command',
      // QR scan controller / service
      zoneCodeRequired: 'Zone code is required',
      pathIdRequired: 'Path ID is required',
      gateNotFound: 'Unable to resolve gate for this scan',
      gateDirectionNotConfigured:
        'Gate has no entry or exit direction configured',
      weighbridgeZoneNotAllowed:
        'Weighbridge zone is not allowed for this entry type',
      employeeNotFound: 'Employee not found or is not active',
      orderNoFactory: 'Order has no factory assigned',
      gateNoFactory: 'Gate has no factory assigned',
      factoryMismatch:
        'Factory mismatch — vehicle is registered to a different factory',
      orderNoId: 'Order has no numeric ID',
      queueTicketRequired:
        'Queue ticket required. Please visit the kiosk to join the queue.',
      sapSalesOrderRequired:
        'SAP Sales Order not created. Please rejoin the queue at the kiosk.',
      noAuthorizedAccess: 'No authorized access found for this license plate',
      visitCannotCheckIn:
        'Access denied — visit is not yet approved or scheduled',
      visitBlacklisted: 'Access denied — visitor is on the restricted list',
      visitTooEarly:
        'Access denied — vehicle arrived before the scheduled time window',
      visitExpired: 'Access denied — visit authorization has expired',
      visitCannotCheckOut: 'Visit cannot check out — not checked in',
      // Camera controller / service
      noGateForCamera: 'No gate linked to this camera',
      cannotResolveFactory: 'Cannot resolve factory from order',
      factoryNotFound: 'Factory not found',
      invalidLicensePlate: 'Invalid license plate format',
      gateDirectionMismatch: 'Gate direction mismatch',
      // Additional keys
      cameraReadingFailed: 'Failed to process camera reading',
      gateResolveFailed: 'Unable to resolve gate for this scan',
      gateNoDirection: 'Gate has no entry or exit direction configured',
      weighbridgeZoneForbiddenEmployee:
        'Weighbridge zone is not permitted for employee access',
      weighbridgeZoneForbiddenVisitor:
        'Weighbridge zone is not permitted for visitor access',
      licensePlateInvalid: 'Invalid license plate format',
      weighbridgeMeasurementsMissing:
        'Cannot exit — required weighbridge measurements are missing',
      weighbridgeNoStage: 'Weighbridge gate has no weight stage configured',
      queueExitFailed: 'Failed to release queue slot — please try again',
      scaleNotClear:
        'Scale is not clear — another truck may still be on the platform. Please check before retrying.',
      // Scan / assign-resource / fulfillment controller
      scanFailed: 'Failed to scan order',
      suggestResourcesFailed: 'Failed to suggest resources',
      assignResourceFailed: 'Failed to assign resource',
      resourceRequired: 'Resource is required',
      licensePlateOrPhoneRequired: 'License plate or driver phone is required',
      startProcessingFailed: 'Failed to start processing order',
      generatePdfFailed: 'Failed to generate order PDF',
      syncInvoicesFailed: 'Failed to sync invoices for order',
      fetchLifecycleFailed: 'Failed to fetch order lifecycle',
      markDeliveredFailed: 'Failed to mark shipment as delivered',
      noAssetType:
        'No active asset type found. Please configure at least one Asset Type.',
      invalidAssetType: 'Invalid Asset Type configuration',
      cannotDeliverCancelledShipment:
        'Cannot mark a cancelled shipment as delivered',
      createResourceFailed: 'Failed to create resource',
      createDriverFailed: 'Failed to create driver',
      createVehicleFailed: 'Failed to create vehicle',
      // Gate / scale hardware errors (from weighbridge-controller)
      zkbioUnreachable: 'Unable to reach ZKBio gate device',
      zkbioInvalidResponse: 'Invalid response from ZKBio gate device',
      zkbioGateError: 'ZKBio gate error',
      gateOpenFailed: 'Gate open failed',
      gateCloseFailed: 'Gate close failed',
      gateAcknowledgeFailed: 'Gate did not acknowledge the command',
      gateStatusIsapiFailed: 'Failed to read gate status',
      gateStatusFailed: 'Failed to read gate status',
      scaleReadFailed: 'Scale read failed: maximum retry attempts exceeded',
      // Command payload errors
      missingGateIp: 'Gate IP address is not configured for this command',
      invalidDirection: 'Direction must be inbound or outbound',
      unsupportedShipmentId:
        'Shipment ID is not supported for inbound weighbridge flow. Use shipment number instead.',
      mixedIdentifiers:
        'Use either an outbound order number or an inbound shipment number, not both.',
      missingOrderNumber: 'Order number is required',
      missingShipmentNumber: 'Shipment number is required',
      missingWeightStage: 'Weight stage must be first_weight or second_weight',
      invalidWeight: 'Weight must be a non-negative number',
      orderAlreadyQueued:
        'This order is already queued in this weighbridge zone',
      zoneLocked: 'Weighbridge zone is locked — open the exit gate to unlock',
      zoneBusy: 'Weighbridge zone is busy — please wait and try again',
      controllerRequestFailed:
        'Controller request failed. {{reason}}',
      // Hardware controller errors
      cameraEventFailed: 'Failed to process camera event',
      qrScanFailed: 'Failed to process QR scan',
      // ZKBio gate / door poller
      zkbioOpenFailed: 'Failed to open gate {{gateCode}}',
      zkbioDoorTimeout: 'Gate did not close within the expected time',
      // ANPR / camera
      anprMissingPlate: 'License plate not found in camera reading',
      anprRejected: 'Camera reading rejected by server',
      anprForwardFailed: 'Failed to forward camera reading to server',
      // QR scan
      qrMissingOrderNumber: 'QR scan does not include an order number',
      qrRejected: 'QR scan rejected by server',
      qrForwardFailed: 'Failed to forward QR scan to server',
      // Weighbridge flow
      duplicateFlow:
        'Order {{orderNumber}} is already in progress for this stage',
      orderAlreadyWeighed:
        'This weight has already been recorded for {{orderNumber}}',
      weightSubmissionFailed:
        'Weight submission failed — stage locked for {{flowLabel}} {{identifier}}: {{strapiError}}',
      strapiUnauthorized: 'Weight submission unauthorized',
      strapiForbidden: 'Weight submission forbidden — insufficient permissions',
      strapiUnreachable: 'Could not reach the Strapi server — check the network connection and try again',
      flowFailed: 'Weighbridge flow failed',
      weightReadFailed: 'Weight read failed',
      gateTestFailed: 'Test gate open failed',
      // Inbound shipment stage guards (incoming-materials/inbound-flow.functions.ts)
      firstWeightStageLocked:
        'Cannot record first weight — shipment status is "{{status}}" (expected "arrived")',
      secondWeightBeforeFirst: 'Cannot record second weight before first weight',
      secondWeightStageLocked:
        'Cannot record second weight — shipment status is "{{status}}" (expected "first weight done" or "unloaded")',
      finalizeStageLocked:
        'Cannot finalize shipment — status is "{{status}}" (expected "second weight done")',
      exitBeforeSecondWeight:
        'Cannot exit — shipment status is "{{status}}". Second weight must be recorded first',
      goodsReceiptAlreadyExists: 'Shipment already has a goods receipt',
      // Inbound weight recording (api/inbound-shipment/controllers/inbound-shipment.ts recordWeight)
      weightTypeInvalid: 'Weight type must be "F" or "S"',
      fieldMustBePositive: '{{field}} must be a positive number',
      invalidShipmentId: 'Invalid shipment id',
      poMissingSapNumberForWeight:
        'Linked purchase order has no SAP purchase order number — cannot push weight to SAP',
      sapWeightPushFailed: 'Weight recorded locally but SAP push failed: {{reason}}',
      noWeighbridgeTicketForShipment: 'No weighbridge ticket found for this shipment',
      firstWeightTicketMissingGross: 'First weight ticket has no gross weight',
      shipmentMissingPurchaseOrder: 'Shipment has no linked purchase order',
      noPurchaseOrderLinesForGrn: 'No purchase order lines found for auto-GRN',
      grnSapPushFailed: 'GRN created but SAP push failed: {{reason}}',
      secondWeightGrnFailed: 'Second weight recorded but auto-GRN creation failed: {{reason}}',
      // Pre-existing keys thrown by the backend but missing a translation until now
      fetchOrderDetailsFailed: 'Failed to fetch order details',
      inboundShipmentNotFound: 'Inbound shipment not found',
      platePairingRequired:
        'No license plate reading found for this vehicle — gate will not open',
      inboundQrDisabled: 'Inbound registration is not enabled at this site',
      purchaseOrderNumberRequired: 'Purchase order number is required',
      purchaseOrderLineRequired: 'Select which load you are delivering',
      purchaseOrderLineNotFound: 'This purchase order has no such line',
      purchaseOrderNotSyncedToSap:
        'Purchase order is not yet synced to SAP — cannot register arrival',
      vehicleAlreadyInside:
        'This vehicle already has an open delivery — it must leave before starting another',
      purchaseOrderNotFound: 'Purchase order not found',
      purchaseOrderCancelled: 'Purchase order is cancelled',
      purchaseOrderClosed: 'Purchase order is closed',
      sapSalesOrderNumberRequired: 'Order has no SAP sales order number',
      sapWeightSyncDisabled: 'SAP weight sync is disabled',
      secondWeighAlreadyCompleted: 'Second weigh has already been completed',
    },
    info: {
      gateOpened: 'Gate {{gateCode}} opened',
      gateClosed: 'Gate {{gateCode}} closed',
      orderQueuedLocked:
        'Order {{orderNumber}} queued — waiting for zone {{weightStage}} to unlock',
      orderQueued: 'Order {{orderNumber}} queued at position {{position}}',
      flowCompleted:
        'Weighbridge flow completed — order {{orderNumber}}, {{weight}}kg',
      anprAccepted: 'Camera reading accepted',
      scanAccepted: 'QR scan accepted',
      gateTestOpened: 'Test gate opened successfully',
    },
  },
};
